import { gql, TypedDocumentNode } from "@apollo/client";

import { AiProvider, QueryAvailableAiProvidersArgs } from "types/generated";

export const GET_AVAILABLE_AI_PROVIDERS: TypedDocumentNode<
  { availableAIProviders: AiProvider[] },
  QueryAvailableAiProvidersArgs
> = gql`
  query GetAvailableAiProviders($provider: String) {
    availableAIProviders(provider: $provider) {
      provider
    }
  }
`;
